import { useQuery } from "react-query";
import { MRT_PaginationState } from "mantine-react-table";
import getCollectionsListing, {
  CollectionsListingResponse,
} from "../services/getCollectionsListing";
function useGetCollectionsListing(
  token: string,
  externalAccount: string,
  pagination: MRT_PaginationState,
  refreshKey: number,
  startDate?: string,
  endDate?: string
) {
  return useQuery<CollectionsListingResponse>({
    queryKey: [
      "getCollectionsListing",
      externalAccount,
      pagination,
      refreshKey,
      startDate,
      endDate,
    ],
    queryFn: () =>
      getCollectionsListing({
        token,
        externalAccount,
        pagination,
        startDate,
        endDate,
      }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetCollectionsListing;
